import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap';
import { RequisitionActivityModalComponent } from './requisition-activity-modal.component';
import { RequisitionsModule } from 'src/app/features/requisitions/requisitions.module';

@NgModule({
  declarations: [RequisitionActivityModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    RequisitionsModule
  ],
  exports: [RequisitionActivityModalComponent],
  entryComponents: [RequisitionActivityModalComponent]
})
export class RequisitionActivityModalModule { }
